import { service } from "@ember/service";
import { dropTask } from "ember-concurrency";
import destroyRecord from "glesys-controlpanel/utils/destroy-record";
import ENV from "glesys-controlpanel/config/environment";
import DnsDomainController from "../controller";
import { saveRecord } from "@warp-drive/legacy/compat/builders";

export default class DnsDomainDnssecController extends DnsDomainController {
  @service abilities;
  @service intl;
  @service store;

  updateDnssecState(response, enabled) {
    this.store.push(
      this.store.normalize("dns-domain", {
        domainname: this.domain.id,
        dnssec: {
          ...this.domain.dnssec,
          enabled: enabled ? "yes" : "no",
          records: response?.records || [],
        },
      }),
    );
  }

  get showDnssecToggle() {
    return this.tldSupportsDnssec && this.domain.usingglesysnameserver;
  }

  get showSystemRecords() {
    return this.tldSupportsDnssec && this.domain.usingglesysnameserver && this.domain.dnssec?.enabled === "yes";
  }

  get showDnssecRecords() {
    return this.showSystemRecords || this.supportsCustomDnssecRecords;
  }

  createDnssecRecordTask = dropTask(async (properties) => {
    Object.assign(properties, { domain: this.domain });

    const dnssecRecord = this.store.createRecord("dnssec-record", properties);

    await this.store.request(saveRecord(dnssecRecord)).catch((error) => {
      dnssecRecord.unloadRecord();
      throw error;
    });

    this.notification.add(
      "success",
      this.intl.t("dns.domain.dnssec.notifications.record-added.title"),
      this.intl.t("dns.domain.dnssec.notifications.record-added.text"),
    );
  });

  deleteDnssecRecordTask = dropTask(async (dnssecRecord) => {
    await destroyRecord(dnssecRecord);

    this.notification.add(
      "success",
      this.intl.t("dns.domain.dnssec.notifications.record-deleted.title"),
      this.intl.t("dns.domain.dnssec.notifications.record-deleted.text"),
    );
  });

  toggleDnssec = dropTask(async () => {
    if (this.domain.dnssec?.enabled === "yes") {
      const response = await this.ajax.post(`${ENV.apiBaseUri}/domain/disablednssec`, {
        data: {
          domainname: this.domain.domainname,
        },
      });

      this.updateDnssecState(response, false);

      this.notification.add(
        "success",
        this.intl.t("dns.domain.dnssec.notifications.disabled.title"),
        this.intl.t("dns.domain.dnssec.notifications.disabled.text"),
      );
    } else {
      const response = await this.ajax.post(`${ENV.apiBaseUri}/domain/enablednssec`, {
        data: {
          domainname: this.domain.domainname,
        },
      });

      this.updateDnssecState(response, true);

      this.notification.add(
        "success",
        this.intl.t("dns.domain.dnssec.notifications.enabled.title"),
        this.intl.t("dns.domain.dnssec.notifications.enabled.text"),
      );
    }
  });
}
